// @flow

import React from 'react';

import type { BackgroundImage } from './types';
import type { ACFRow as ACFRowProps, ACFImage } from '../../types';
import Row from './row';
import ComponentColumn from '../componentColumn';
import TabsColumn from '../tabsColumn';
import { getValueOrArrayHead, generateSlug } from '../../helpers';
import { getColumnsResponsiveData } from './helpers';
import { ColumnWrapper } from './atoms';

type OwnProps = {|
  sticky?: boolean,
|};

type Props = {
  ...OwnProps,
  ...ACFRowProps,
};

const complementImages = (image: ACFImage, image_mobile?: ACFImage): BackgroundImage => ({
  xs: image_mobile ? image_mobile.sizes.medium_large : image.sizes.medium_large,
  sm: image_mobile ? image_mobile.sizes.medium_large : image.sizes.medium_large,
  md: image.sizes.large,
  lg: image.url,
});

const ACFRow = ({
  use_image,
  image,
  image_mobile,
  columns,
  background_color,
  cut,
  cut_color,
  use_gradient,
  gradient_opacity,
  sticky,
  template,
  slideshow,
  name,
}: Props) => {
  const responsiveData = getColumnsResponsiveData(columns);

  return (
    <Row
      id={name && generateSlug(name)}
      backgroundColor={background_color}
      cut={cut}
      cutColor={getValueOrArrayHead(cut_color)}
      backgroundImage={
        use_image
        && typeof image === 'object'
        && complementImages(image, image_mobile)
      }
      sticky={sticky}
      gradient={use_gradient && gradient_opacity}
    >
      <ColumnWrapper
        columnCount={columns ? columns.length : 0}
        slideshow={slideshow}
      >
        {columns && columns.map((column, index) => {
          if (column.has_tabs) {
            return (
              <TabsColumn
                key={index} // eslint-disable-line
                column={column}
                responsiveData={responsiveData[index]}
                rowTemplate={template || 'default'}
                slideshow={slideshow}
                cut={cut}
                index={index}
              />
            );
          }

          return (
            <ComponentColumn
              key={index} // eslint-disable-line
              column={column}
              responsiveData={responsiveData[index]}
              rowTemplate={template || 'default'}
              slideshow={slideshow}
              cut={cut}
              index={index}
            />
          );
        })}

      </ColumnWrapper>
    </Row>
  );
};

ACFRow.defaultProps = {
  sticky: false,
};

export default ACFRow;
